import React from 'react';
import PropTypes from 'prop-types';
import { isValidArray } from '../../../utilities/validations';

const ItemList = ({ items, domain = 'https://www.pella.com' }) => {
	// Loop through list items to create ListItem objects
	let listItems = [];

	if (isValidArray(items)) {
		for (let x = 0; x < items.length; x++) {
			listItems[x] = `{
				"@type": "ListItem",
				"position": ${x + 1},
				"url": "${domain + items[x].url}"
			}`;
		}
	}

	return (
		<script
			type='application/ld+json'
			dangerouslySetInnerHTML={{
				__html: `{
				"@context": "https://schema.org",
				"@type": "ItemList",
				"itemListElement": [
					${isValidArray(listItems) ? [...listItems] : ''}
				]
			}`,
			}}
		/>
	);
};

ItemList.propTypes = {
	items: PropTypes.array,
	domain: PropTypes.string,
};

export default ItemList;
